import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useReply(conversationId: number | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ text, isNote }: { text: string; isNote?: boolean }) =>
      api.reply(conversationId!, text, isNote),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["messages", conversationId] });
      qc.invalidateQueries({ queryKey: ["conversations"] });
    },
  });
}

export function useChangeStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: string }) => api.changeConversationStatus(id, status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["conversations"] });
      toast.success("Estado actualizado");
    },
  });
}
